import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from '@angular/common';
import {environment} from "../../../environments/environment";
import {MatSelectModule} from "@angular/material/select";
import {MatFormFieldModule} from "@angular/material/form-field";
import {BreadcrumbService} from "xng-breadcrumb";
import {Lightbox} from "@pierresh/ngx-lightbox";
import {ListingDetailService} from "./listing-detail.service";
import {ProductSingle} from "../../productsingle/product-single";
import {Globals} from "../../globals";
import {
  applyBrowseTaxonomyBreadcrumbs,
  globalsBrowseFilter,
  taxonomyUrlSegments,
} from '../../shared/listing-route.utils';
import {NavigationTrackerService} from "../../shared/navigation-tracker.service";
import {TokenStorageService} from "../../_services/token-storage.service";
import {buildListingFilterParams} from '../../shared/listing-filter.utils';
import {MessagingService} from "../../messaging/messaging.service";
import {AttributeSchemaService, ListingAttributeValueView} from '../../shared/attribute-schema.service';
import {AppConfigService} from '../../shared/app-config.service';
import {HttpClient} from '@angular/common/http';
import {SeoService} from '../../shared/seo.service';
import {dropshipShipsInLabel, isDropshipListing} from '../../shared/fulfillment.utils';
import {BrowseHistoryService} from '../../shared/browse-history.service';
import {browsePathSegments} from '../../shared/browse-seo.utils';
import {BrandThemeService} from '../../shared/brand-theme.service';
import {AllService} from '../../all/all.service';
import {listingThumbnailUrl} from '../../shared/listing-image.utils';
import {itemNavState} from '../../shared/item-url.utils';
import {Subscription} from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-listing-detail',
  templateUrl: './listing-detail.component.html',
  styleUrls: ['./listing-detail.component.css', './listing-detail.component.scss'],
  imports: [MatFormFieldModule, MatSelectModule]
})
export class ListingDetailComponent implements OnInit, OnDestroy {
  @Input() currentUserId: string;
  @Input() otherUserId: string;
  environment: any;
  isShow = true;
  id:string;
  photosTemp: any;
  itemSingle: any = new ProductSingle();
  itemsShop: any = [];
  photo: any = 'assets/images/cat-2.jpg';
  // photos: any;
  imageSrc: any;
  url: any;
  urls: any;

  // Add these properties to match AllMotorChildComponent
  vehicleSpecVisible = false;
  advancedFilterVisible = false;
  safetyFeaturesVisible = false;
  comfortFeaturesVisible = false;
  infotainmentFeaturesVisible = false;
  environmentalRatingVisible = false;
  efficiencyPerformanceVisible = false;

  slideConfig = {
    "slidesToShow" : 1,
    "slidesToScroll" : 1,
    "dots" : true,
    "infinite" : false,
    // "autoRotate" : true,
    // "autoRotateAfter" : 5000,
    "autoplay" : true,
    "autoplaySpeed" : 10000
  };

  photos: any[] = [];
  selectedImageIndex = 0;
  isLightboxOpen = false;
  private is360Active = false;
  private startX = 0;
  private currentRotation = 0;
  showContactModal = false;
  showReportModal = false;
  messageText = '';
  messageReportText = '';
  reportError = '';
  reportSuccess = '';
  reporting = false;
  listingAttributes: ListingAttributeValueView[] = [];
  private routeSub?: Subscription;
  private envReady = false;

  constructor(private token: TokenStorageService,
              private messagingService: MessagingService,
              private http: HttpClient,
              private attributeSchemaService: AttributeSchemaService,
              private appConfigService: AppConfigService,
              private route:ActivatedRoute,
              private router: Router,
              private _lightbox: Lightbox,
              private breadcrumbService: BreadcrumbService,
              private allViewItemService: ListingDetailService,
              public globals: Globals,
              public location: Location,
              private navigationTracker: NavigationTrackerService,
              private cd: ChangeDetectorRef,
              private seoService: SeoService,
              private browseHistory: BrowseHistoryService,
              private allService: AllService,
              private brandThemeService: BrandThemeService) {

  }

  is360Image(photo: any): boolean {
    return photo.type === '360' || photo.image.includes('360');
  }

  start360View(event: MouseEvent): void {
    if (!this.is360Image(this.photos[this.selectedImageIndex])) return;

    this.is360Active = true;
    this.startX = event.clientX;
    event.preventDefault();
  }

  handle360View(event: MouseEvent): void {
    if (!this.is360Active) return;

    const deltaX = event.clientX - this.startX;
    this.currentRotation = (deltaX / window.innerWidth) * 360;

    const img = event.target as HTMLElement;
    img.style.transform = `rotateY(${this.currentRotation}deg)`;
  }

  end360View(): void {
    this.is360Active = false;
  }

  selectImage(index: number): void {
    this.selectedImageIndex = index;
  }

  openLightbox(index: number): void {
    this.selectedImageIndex = index;
    this.isLightboxOpen = true;
  }

  closeLightbox(): void {
    this.isLightboxOpen = false;
  }

  nextImage(): void {
    this.selectedImageIndex = (this.selectedImageIndex + 1) % this.photos.length;
  }

  prevImage(): void {
    this.selectedImageIndex = this.selectedImageIndex === 0 ? this.photos.length - 1 : this.selectedImageIndex - 1;
  }


  ngOnInit(): void {
    if (this.token.getUser()) {
      this.currentUserId = this.token.getUser().username;
    }
    this.globals.isView = true;

    environment.then(env => {
      this.imageSrc = env['images'];
      this.url = env['backendURL'];
      this.environment = env;
      this.envReady = true;
      this.loadCurrentListing();
    });

    // Re-load when navigating between items (similar listings, etc.) — component may be reused.
    this.routeSub = this.route.paramMap.pipe(
      map(params => params.get('id') || ''),
      distinctUntilChanged(),
    ).subscribe(id => {
      if (!id || !this.envReady) {
        return;
      }
      this.loadCurrentListing();
    });
  }

  /** Sync route id/taxonomy + fetch item + similar peers. */
  private loadCurrentListing(): void {
    window.scrollTo(0, 0);

    const nextId = this.route.snapshot.paramMap.get('id');
    if (!nextId) {
      return;
    }
    this.id = nextId;

    // Seller scope must match THIS navigation. Stale endUser from a previous item
    // causes /item lookup to 404 when the similar listing belongs to another seller.
    const navState = (this.router.getCurrentNavigation()?.extras?.state
      || history.state
      || {}) as { endUser?: string };
    this.globals.listingFilter.endUser = navState.endUser || null;

    this.urls = taxonomyUrlSegments(this.router.url, this.id);
    globalsBrowseFilter(this.urls, this.globals);
    applyBrowseTaxonomyBreadcrumbs(this.breadcrumbService, this.router.url, this.id);

    this.photos = [];
    this.photosTemp = [];
    this.photo = 'assets/images/cat-2.jpg';
    this.selectedImageIndex = 0;
    this.listingAttributes = [];
    this.itemsShop = [];
    this.itemSingle = new ProductSingle();

    if (!this.url) {
      return;
    }
    this.getItem();
    this.getSimilarItems();
  }

  private get itemEndpointSuffix(): string {
    return '';
  }

  private getItem() {
    if (!this.url || !this.id) {
      return;
    }
    const profile = this.globals.listingFilter.profile;
    const context = buildListingFilterParams(this.globals.listingFilter as Record<string, unknown>);
    this.allViewItemService.getItem(this.url, this.itemEndpointSuffix, this.id, profile, context)
      .subscribe({
        next: (response: any) => {
          // Ignore stale responses after a faster subsequent navigation.
          const responseSlug = `${response?.item?.url || response?.url || ''}`.toLowerCase();
          const responseId = `${response?.item?.itemId || response?.itemId || ''}`.toLowerCase();
          const wanted = `${this.id}`.toLowerCase();
          if (responseSlug && responseSlug !== wanted && responseId !== wanted) {
            return;
          }
          this.itemSingle = response?.item ? response : {item: response};
          // Keep endUser aligned with the loaded seller for any follow-on calls.
          const seller = this.itemSingle?.item?.account?.url
            || this.itemSingle?.item?.accountById?.url;
          if (seller) {
            this.globals.listingFilter.endUser = seller;
          }
          this.loadListingAttributes(response);
          this.breadcrumbService.set('@par' ,this.itemSingle.item.name.toUpperCase());
          this.breadcrumbService.set('@p' ,this.itemSingle.item.name.toUpperCase());
          this.getPhotos(this.itemSingle.item);
          this.applyListingSeo();
          this.browseHistory.recordViewed(
            this.itemSingle.item,
            browsePathSegments(this.router.url).slice(0, -1)
          );
          this.cd.markForCheck();
        },
        error: (err) => {
          console.error(err);
          this.cd.markForCheck();
        }
      });
  }

  private loadListingAttributes(response: any): void {
    this.appConfigService.attributesEnabled().subscribe(enabled => {
      if (!enabled) {
        this.listingAttributes = [];
        this.cd.markForCheck();
        return;
      }
      if (response?.attributes?.length) {
        this.listingAttributes = response.attributes;
        this.applyListingSeo();
        this.cd.markForCheck();
        return;
      }
      const itemId = response?.item?.itemId ?? response?.itemId;
      if (!itemId || !this.url) {
        this.listingAttributes = [];
        return;
      }
      this.attributeSchemaService.getListingAttributes(String(itemId)).subscribe({
        next: attributes => {
          this.listingAttributes = attributes || [];
          this.applyListingSeo();
          this.cd.markForCheck();
        },
        error: () => {
          this.listingAttributes = [];
          this.cd.markForCheck();
        }
      });
    });
  }

  private getSimilarItems() {
    this.itemsShop = [];
    if (!this.url) {
      return;
    }
    const base = buildListingFilterParams(this.globals.listingFilter as Record<string, unknown>);
    // Taxonomy only — ignore keyword/price/attribute leftovers from prior browse.
    const params: Record<string, unknown> = {
      page: 0,
      pageSize: 12,
    };
    for (const key of [
      'profile', 'path', 'category', 'subcategory', 'subSubcategory', 'subSubSubcategory',
      'subSubSubSubcategory', 'subSubSubSubSubcategory', 'subSubSubSubSubSubcategory',
      'subSubSubSubSubSubSubcategory', 'subSubSubSubSubSubSubSubcategory',
    ]) {
      if (base[key] != null && base[key] !== '') {
        params[key] = base[key];
      }
    }
    this.allService.getWithDataHeader(`${this.url}/api/listings/search`, params).subscribe({
      next: (response) => {
        const rows = Array.isArray(response?.items) ? response.items : [];
        const currentSlug = `${this.id || ''}`.trim().toLowerCase();
        this.itemsShop = rows
          .filter((row: any) => {
            const item = row?.item || row;
            if (!item) {
              return false;
            }
            const slug = `${item.url || ''}`.trim().toLowerCase();
            const itemId = `${item.itemId || ''}`.trim().toLowerCase();
            return slug !== currentSlug && itemId !== currentSlug;
          })
          .slice(0, 8);
        this.cd.markForCheck();
      },
      error: () => {
        this.itemsShop = [];
        this.cd.markForCheck();
      }
    });
  }

  similarItemRoute(item: any): string[] {
    return this.browseHistory.buildItemRoute(item, this.urls || []);
  }

  similarItemState(item: any): { endUser?: string } {
    return itemNavState(item);
  }

  similarItemPhoto(item: any): string {
    return listingThumbnailUrl(this.imageSrc, item?.photo) || 'assets/images/cat-2.jpg';
  }

  get sellerAvatarUrl(): string {
    return this.brandThemeService.resolveMediaUrl(
      this.itemSingle?.item?.account?.avatarUrl, this.imageSrc);
  }

  get sellerShopLink(): any[] | null {
    const url = this.itemSingle?.item?.account?.url;
    return url ? ['/', url] : null;
  }

  private getPhotos(photo: any) {
    if (photo.photo) {
      this.photosTemp = photo.photo.split(";");
      this.photos = [];
      this.photosTemp.forEach(o => {
        if (o !== '') {
          let str = this.imageSrc + o;
          this.photos.push({'image': str});
          this.photo = this.photos[0];
        }
      });
      this.photosTemp = [];
      this.photos.forEach (o => {
        const src = o.image;
        const caption = 'Image ' + o.image + ' caption here';
        const thumb = o.image;
        const album = { src: src, caption: caption, thumb: thumb };
        this.photosTemp.push(album);
      });

      // console.log('test', this.photosTemp);
    }
    this.applyListingSeo();
  }

  private applyListingSeo(): void {
    const item = this.itemSingle?.item;
    if (!item?.name) {
      return;
    }
    const imageUrls = (this.photos || [])
      .map((p: any) => p?.image)
      .filter((u: string) => !!u);
    if (!imageUrls.length && this.photo && typeof this.photo === 'string' && this.photo.startsWith('http')) {
      imageUrls.push(this.photo);
    }
    const sellerName = item.account?.name || item.accountById?.name || null;
    this.seoService.applyListingProduct({
      name: this.listingTitle || item.name,
      description: item.description,
      price: item.value,
      currency: 'EUR',
      status: item.status,
      imageUrls,
      pageUrl: typeof window !== 'undefined' ? window.location.href.split('?')[0] : undefined,
      sellerName,
      brand: item.make || this.itemSingle?.make || sellerName,
      attributes: (this.listingAttributes || [])
        .filter(a => a.buyerVisible !== false)
        .map(a => ({
        label: a.label || a.code,
        displayValue: a.displayValue,
        code: a.code
      }))
    });
  }

  get listingTitle(): string {
    if (this.itemSingle?.make) {
      return [this.itemSingle.year, this.itemSingle.make, this.itemSingle.model]
        .filter(part => part != null && `${part}`.trim())
        .join(' ');
    }
    return this.itemSingle?.item?.name ?? '';
  }

  get isDropship(): boolean {
    return isDropshipListing(this.listingAttributes);
  }

  get dropshipShipsLabel(): string | null {
    return dropshipShipsInLabel(this.listingAttributes);
  }

  get canBuy(): boolean {
    const value = this.itemSingle?.item?.value;
    return value != null && Number(value) > 0;
  }

  buyNow(): void {
    const itemId = this.itemSingle?.item?.itemId;
    if (!itemId) {
      return;
    }
    if (!this.token.getToken()) {
      this.router.navigate(['/login'], {
        queryParams: {returnUrl: `/checkout?itemId=${itemId}`}
      });
      return;
    }
    this.router.navigate(['/checkout'], {queryParams: {itemId}});
  }

  get locationLabel(): string {
    const loc = this.itemSingle?.item?.location;
    if (!loc) {
      return '';
    }
    return [loc.city, loc.region, loc.abbreviation].filter(Boolean).join(', ');
  }

  getItems(safetyFeature :any): void { // open lightbox
    return safetyFeature.split(',').map(item => item.trim());
  }

  open(index: number): void { // open lightbox
    this._lightbox.open(this.photosTemp, index);
  }

  close(): void { // close lightbox programmatically
    this._lightbox.close();
  }

  changeIsShow() {
    this.isShow = false;
    // console.log('isShow test', this.isShow);
  }

  onLike(pageNumber: string) {
    console.log('Like button clicked', pageNumber);
    this.allViewItemService.getLikes(this.url + '/item/like', pageNumber)
      .subscribe(response => {
        let o: any = response;
        console.log(response);
        const nextLike = o?.item?.like ?? o?.like;
        if (nextLike != null && this.itemSingle?.item) {
          this.itemSingle.item.like = nextLike;
        }
        this.cd.detectChanges();
      })
    console.log('Like button clicked', pageNumber);
  }

  navigateToChild(childRoute: string) {
    if (childRoute.includes('all-motor-child')) {
      this.navigationTracker.setFromListingDetail(true);
      sessionStorage.setItem('listing_filter_snapshot', JSON.stringify(this.globals.listingFilter));
    }
    this.router.navigate([childRoute]);
  }

  navigateBack() {
    this.location.back();
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
    this.globals.isView = false;
    this.seoService.clearListingProduct();
  }

  openContactModal() {
    this.showContactModal = true;
  }

  closeContactModal() {
    this.showContactModal = false;
    this.messageText = '';
  }

  sendMessage() {
    if (!this.messageText.trim()) return;

    const message = {
      senderId: this.currentUserId,
      receiverId: this.itemSingle.item.account.name,
      content: this.messageText,
      itemId: this.itemSingle.item.itemId
    };
    console.log('this.messageText', message);

    this.messagingService.sendMessage(this.url + '/api/messages', message).subscribe(() => {
      this.messageText = '';
      this.closeContactModal();
    });
  }

  openReportModal() {
    this.showReportModal = true;
    this.reportError = '';
    this.reportSuccess = '';
  }

  closeReportModal() {
    this.showReportModal = false;
    this.messageReportText = '';
    this.reportError = '';
    this.reportSuccess = '';
    this.reporting = false;
  }

  sendReportMessage() {
    const text = (this.messageReportText || '').trim();
    if (!text) {
      this.reportError = 'Please describe the issue.';
      return;
    }
    const itemId = this.itemSingle?.item?.itemId;
    if (!itemId) {
      this.reportError = 'Listing id missing.';
      return;
    }
    if (!this.token.getUser()) {
      this.reportError = 'Please sign in to submit a report.';
      return;
    }

    this.reporting = true;
    this.reportError = '';
    this.http.post(`${this.url}/api/reports/listing`, {
      itemId,
      title: 'Listing report',
      text
    }).subscribe({
      next: () => {
        this.reporting = false;
        this.reportSuccess = 'Thanks — your report was submitted.';
        this.messageReportText = '';
        setTimeout(() => this.closeReportModal(), 900);
      },
      error: err => {
        this.reporting = false;
        this.reportError = err?.error?.message || err?.error?.error || 'Failed to submit report.';
      }
    });
  }
}

/** @deprecated Use ListingDetailComponent */
export {ListingDetailComponent as UpdateListingDetailComponent};

